export enum PricingCycleActivation {
  PRICE = 'PRICE',
  QUANTITY = 'QUANTITY',
  NONE = 'NONE',
}
